import { render, staticRenderFns } from "./GroupServiceProviders.vue?vue&type=template&id=46c0b606&scoped=true&"
import script from "./GroupServiceProviders.vue?vue&type=script&lang=js&"
export * from "./GroupServiceProviders.vue?vue&type=script&lang=js&"
import style0 from "./GroupServiceProviders.vue?vue&type=style&index=0&id=46c0b606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0b606",
  null
  
)

export default component.exports